// ============================================================================
// navigate.ts — ЕДИНСТВЕННАЯ точка навигации (BrowserRouter, без hash).
// Все переходы через router.navigate — детерминированно, никаких window.location
// и фоллбэков. Роутер обязан быть зарегистрирован (см. routerInstance.ts).
// Чистые URL: лаунчер → '/', дизайнер → '/designer',
// публикация → '/enterprise/{slug}'. НИКАКОГО /login — единая точка входа:
// лаунчер → выбор базы → /designer (вход) или /enterprise/{slug} (вход+рабочее).
// ============================================================================

import { getRouter } from './routerInstance';
import { useCenterStore } from '@/store/centerStore';

export function navigateTo(path: string, opts?: { state?: unknown; replace?: boolean }): void {
  if (typeof window === 'undefined') return;
  getRouter().navigate(path, opts);
}

// Канонические переходы (единые для всех клиентов: desktop, web, PWA)
export const goLauncher = () => navigateTo('/');
export const goDesigner = () => navigateTo('/designer');
export const goEnterprise = (slug: string) => navigateTo(`/enterprise/${encodeURIComponent(slug)}`);

/**
 * goAuthGate — переход к ВХОДУ/РЕГИСТРАЦИИ из приложения (витрины, PWA).
 *
 * В опубликованной базе (/enterprise/{slug}) остаёмся на том же URL: оболочка
 * покажет форму входа, а `state` сохранит намерение (например, открыть
 * приложение после входа). В конфигураторе роль входа играет /designer —
 * ProtectedRoute показывает форму входа на месте.
 */
export function goAuthGate(state?: unknown): void {
  if (typeof window === 'undefined') return;
  const slug = useCenterStore.getState().baseSlug;
  const inPublication = window.location.pathname.startsWith('/enterprise/');
  if (inPublication && slug) {
    navigateTo(`/enterprise/${encodeURIComponent(slug)}`, { state });
    return;
  }
  // Конфигуратор: форма входа показывается на /designer (ProtectedRoute), но
  // state нужен форме входа, чтобы вернуть пользователя в приложение.
  navigateTo('/designer', { state });
}
